import { UPDATE_HYPERLINK_SLIDE } from '../constants/actionTypes'

import { createAction } from 'redux-actions'

export const updateHyperLinkSlide = createAction(UPDATE_HYPERLINK_SLIDE, slide => slide);
